import { Box, Button, Fab, FormControl, IconButton, InputLabel, MenuItem, Select, TextField, Typography, useTheme } from "@mui/material";
import { font } from "../../styles/font";
import { useApplicationContext } from "../../context/ApplicationContext";
import { useNavigate } from "react-router-dom";
import useErrorHandler from "../../api/errorHandler/useErrorHandler";
import { useState } from "react";
import { addLabel_API, getLabelList_API, updateDeleteLabel_API } from "../../api/controller/SettingsController";
import { HttpStatusCode } from "axios";
import { Severity } from "../../constant/ApplicationVariables";
import { Add, Close, DeleteOutline, EditOutlined, Label } from "@mui/icons-material";
import AddUpdateLabelDialog from "../dialog/AddUpdatelabelDialog";
import DeleteConfirmationDialog from "../dialog/DeleteConfirmationDialog";
import { LightTooltip } from "../styled/CustomComponent";
import { getProjectCategoryList_API, getProjectDetail_API, getProjectSubcategoryList_API, updateProject_API } from "../../api/controller/ProjectController";
import { useEffect } from "react";


export default function ConfigurationContainerComponent() {
    const { activeConfiguration, setActiveConfiguration } = useApplicationContext();

    const handleComponent = (value) => {
        switch (value) {
            case "Project": return <ProjectComponent />;
            case "Labels": return <LabelsComponent />;
            default: return null;
        }
    }

    return (
        <Box className=" flex flex-col gap-0   h-full w-full box-border  overflow-hidden  " >

            {/* main container */}
            <Box className="flex-1 flex flex-col gap-4  px-0 py-0 h-full relative overflow-hidden  "    >

                {/* <LabelsComponent /> */}
                {handleComponent(activeConfiguration?.value)}

            </Box>

        </Box>
    )
}


function ProjectComponent() {
    const {
        activeProject, setActiveProject,
        handleSnackbar,
        projectList, setProjectList,
    } = useApplicationContext();

    const theme = useTheme();
    const errorHandler = useErrorHandler();

    const [isLoading, setIsLoading] = useState(false);

    const [projectData, setProjectData] = useState(activeProject);
    const [categoryList, setCategoryList] = useState([]);
    const [subCategoryList, setSubCategoryList] = useState([]);



    // project funciton start
    const handleChange = (e) => {
        if (e.target.name === "categoryName" || e.target.name === "subCategoryName") {
            setProjectData({ ...projectData, [e.target.name]: e.target.value?.name });
        } else {
            setProjectData({ ...projectData, [e.target.name]: e.target.value });
        }

    }

    const handleUpdate = () => {
        handleUpdateProject(projectData);
    }

    const handleGetCategoryList = async () => {
        try {


            const response = await getProjectCategoryList_API();

            if (response.status === HttpStatusCode.Ok) {
                setCategoryList(response.data);

                // handleSnackbar(response.message, Severity.success)
            }

            if (response) {
                errorHandler(response);
            }


            console.log(response, "categoryreponse data")
        } catch (error) {
            console.log(error, "categoryreponse errorr")
        }
    }

    const handleGetsubCategoryList = async () => {
        try {


            let query = `parentName=${projectData?.categoryName}`;

            const response = await getProjectSubcategoryList_API(query);

            if (response.status === HttpStatusCode.Ok) {
                setSubCategoryList(response.data);
                setProjectData({ ...projectData, "subCategoryName": response.data[0]?.name });

                // handleSnackbar(response.message, Severity.success)
            }

            if (response) {
                errorHandler(response);
            }


            console.log(response, "subcategoryreponse data")
        } catch (error) {
            console.log(error, "subcategoryreponse errorr")
        }
    }

    const handleGetProjectDetail = async () => {
        try {
            setIsLoading(true);

            let query = `name=${activeProject?.name}`

            const response = await getProjectDetail_API(query);

            if (response.status === HttpStatusCode.Ok) {
                setProjectData(response.data)
                // handleSnackbar(response.message, Severity.success)
            }

            if (response) {
                errorHandler(response, setIsLoading);
            }

            console.log(response, "handleGetProjectDetail data")
        } catch (error) {
            console.log(error, "handleGetProjectDetail errorr")
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 1000)
        }
    }

    const handleUpdateProject = async (projectData) => {

        if (!projectData?.name || !projectData?.description || !projectData?.categoryName || !projectData?.subCategoryName) {
            return handleSnackbar("Please fill all the fields", Severity.error)
        }

        setIsLoading(true)

        try {
            // setIsLoading(true);

            // let body = { ...projectData };

            let body = {
                // "newName": projectData?.name,
                "currentName": activeProject?.name,
                "lastModifiedAt": activeProject?.lastModifiedAt ? activeProject?.lastModifiedAt : null,
                // "categoryName": projectData?.categoryName,
                // "subCategoryName": projectData?.subCategoryName,
                // "description": projectData?.description,
                // "status": "Archive"
                // "status" : projectData?.status
            }

            if (projectData?.name !== activeProject?.name) {
                body.newName = projectData?.name
            }
            if (projectData?.description !== activeProject?.description) {
                body.description = projectData?.description
            }

            if (projectData?.categoryName !== activeProject?.categoryName) {
                body.categoryName = projectData?.categoryName
            }
            if (projectData?.subCategoryName !== activeProject?.subCategoryName) {
                body.subCategoryName = projectData?.subCategoryName
            }

            if (projectData?.status !== activeProject?.status) {
                body.status = projectData?.status
            }

            if (projectData?.useCasePrefix !== activeProject?.useCasePrefix) {
                body.useCasePrefix = projectData?.useCasePrefix
            }

            if (projectData?.userStoryPrefix !== activeProject?.userStoryPrefix) {
                body.userStoryPrefix = projectData?.userStoryPrefix
            }

            if (projectData?.testCasePrefix !== activeProject?.testCasePrefix) {
                body.testCasePrefix = projectData?.testCasePrefix
            }

            const response = await updateProject_API(body);

            if (response.status === HttpStatusCode.Ok) {
                localStorage.setItem("activeProject", JSON.stringify(response.data));
                setActiveProject(response.data);


                let list = [...projectList];
                let foundIndex = list?.findIndex((item) => item?.name === body.currentName);
                if (foundIndex !== -1) {
                    list[foundIndex] = response.data;
                }
                setProjectList(list);


                // handleGetProjectList();
                // handleCloseMorePopup();
            }

            if (response) {
                errorHandler(response, setIsLoading);
            }

            setTimeout(() => {
                setIsLoading(false);
            }, 1000);

            console.log(response, "projectreponse data");
        } catch (error) {
            console.log(error, "projectreponse errorr");
        }
    }

    // project function end


    useEffect(() => {
        handleGetCategoryList();
    }, []);

    useEffect(() => {
        if (projectData?.categoryName) {
            handleGetsubCategoryList();
        }
    }, [projectData?.categoryName]);

    // useEffect(() => {
    //     setActiveProjectCategory(categoryList[0]);
    // }, []);

    useEffect(() => {
        // setProjectData(activeProject);
        handleGetProjectDetail();
    }, [activeProject]);


    return (
        <Box className="w-full h-full flex flex-col gap-1  " bgcolor={theme.palette.background.paper}>
            <Box className="flex flex-col px-0 py-4 w-full h-full  ">


                <Box className="flex  px-4 py-4 gap-4 " >

                    <Box className="flex-1 flex flex-col gap-4 " >
                        <TextField required name="name" label="Project Name" sx={{ fontSize: font.size.fs_4 }} value={projectData?.name} onChange={handleChange} />
                        <TextField required name="description" label="Project Description" multiline minRows={8.5} sx={{ fontSize: font.size.fs_4 }} value={projectData?.description} onChange={handleChange} />
                    </Box>

                    <Box className="min-w-[46%] flex flex-col gap-4">
                        <Box className="flex items-center justify-between gap-2 ">
                            {/* <Typography>Category</Typography> */}

                            <FormControl required fullWidth>
                                <InputLabel id="demo-simple-select-label-category">Category</InputLabel>
                                <Select
                                    // className="w-44 h-8"
                                    variant="outlined"
                                    name="categoryName"
                                    labelId='demo-simple-select-label-category'
                                    label="Category"
                                    value={projectData?.categoryName}
                                    displayEmpty
                                    renderValue={() => projectData?.categoryName}
                                    onChange={handleChange}
                                >
                                    {
                                        categoryList?.map((item, index) => {
                                            return (
                                                <MenuItem value={item} key={index}>
                                                    {item?.name}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Box>

                        <Box className="flex items-center justify-between gap-2 ">
                            {/* <Typography>SubCategory</Typography> */}
                            <FormControl required fullWidth>
                                <InputLabel id="demo-simple-select-label-subcategory">Subcategory</InputLabel>
                                <Select
                                    // className="w-44 h-8"
                                    variant="outlined"
                                    name="subCategoryName"
                                    labelId='demo-simple-select-label-subcategory'
                                    label="Subcategory"
                                    value={projectData?.subCategoryName}
                                    displayEmpty
                                    renderValue={() => projectData?.subCategoryName}
                                    onChange={handleChange}
                                >
                                    {
                                        subCategoryList?.map((item, index) => {
                                            return (
                                                <MenuItem value={item} key={index}>
                                                    {item?.name}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Box>

                        <TextField required name="useCasePrefix" label="Use Case Prefix" sx={{ fontSize: font.size.fs_4 }} value={projectData?.useCasePrefix} onChange={handleChange} />
                        <TextField required name="userStoryPrefix" label="Use Story Prefix" sx={{ fontSize: font.size.fs_4 }} value={projectData?.userStoryPrefix} onChange={handleChange} />
                        <TextField required name="testCasePrefix" label="Test Case Prefix" sx={{ fontSize: font.size.fs_4 }} value={projectData?.testCasePrefix} onChange={handleChange} />
                    </Box>
                </Box>

            



                <Box className="flex flex-col gap-4 px-4 py-4 border-t">
                    <Button variant="contained" color="secondary" sx={{ width: "min-content", color: theme.palette.secondary.contrastText }} disabled={isLoading} onClick={() => handleUpdate()}>Update</Button>
                    {/* <Button variant="outlined" disabled={isLoading || !projectData?.name || !projectData?.description} onClick={() => handleCloseMorePopup()}>Cancel</Button> */}
                </Box>
            </Box>
        </Box>
    )
}



function LabelsComponent({ }) {
    const {
        handleSnackbar,
        activeProject,

        labelList, setLabelList
    } = useApplicationContext();
    const theme = useTheme();
    const navigate = useNavigate();
    const errorHandler = useErrorHandler();


    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);


    const [labelData, setLabelData] = useState({
        name: "",
        color: "#FF5733",
    });
    const [currentLabelData, setCurrentLabelData] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);



    const handleOpenDialog = (isEdit, item) => {
        setIsEditMode(isEdit);
        setOpenDialog(true);


        if (item && isEdit) {
            setCurrentLabelData(item);
            setLabelData({
                name: item?.name,
                color: item?.colorCode,
            });
        }

    }


    const handleCloseDialog = () => {
        setOpenDialog(false);
        setIsEditMode(false);
        setCurrentLabelData(null);

        setLabelData({
            name: "",
            color: "#FF5733",
        });
    }


    const handleOpenDeleteDialog = (data) => {
        setCurrentLabelData(data);
        setOpenDeleteDialog(true);
    }

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
        setCurrentLabelData(null);
    }

    const handleContinueDeleteDialog = () => {
        setOpenDeleteDialog(false);
        handleContinueUpdate(true);
    }


    const handleGetList = async () => {

        try {

            setLoading(true)


            let body = {
                name: activeProject?.name,
            }

            let query = new URLSearchParams(body).toString();

            const response = await getLabelList_API(query);

            console.log(response, " response in updateprofile")

            if (response) {
                errorHandler(response, setLoading);
            }

            if (response.status === HttpStatusCode.Ok) {
                setLabelList(response.data);

            }

        } catch (error) {
            console.log(error, error?.message, "login errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setTimeout(() => {
                setLoading(false);

            }, 1000);
        }
    }

    const handleContinue = async () => {

        try {

            setLoading(true);


            let body = {
                name: labelData?.name,
                colorCode: labelData?.color,
                projectName: activeProject?.name,
            }

            const response = await addLabel_API(body);

            console.log(response, " response in updateprofile")

            if (response) {
                errorHandler(response, setLoading);
            }

            if (response.status === HttpStatusCode.Ok) {

                handleCloseDialog();
                handleGetList();


                handleSnackbar(response?.data?.message, Severity.success);
            }

        } catch (error) {
            console.log(error, error?.message, "login errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setTimeout(() => {
                setLoading(false);

            }, 1000);
        }
    }

    const handleContinueUpdate = async (isDelete) => {

        try {

            setLoading(true);


            let body = {
                currenName: currentLabelData?.name,
                newName: labelData?.name,
                colorCode: labelData?.color,
                projectName: activeProject?.name,

                delete: isDelete,
                lastModifiedAt: currentLabelData?.lastModifiedAt ? currentLabelData?.lastModifiedAt : null
            }

            if (currentLabelData?.name === labelData?.name) {
                delete body.newName;
            }

            const response = await updateDeleteLabel_API(body);

            console.log(response, " response in updateprofile")

            if (response) {
                errorHandler(response, setLoading);
            }

            if (response.status === HttpStatusCode.Ok) {

                handleCloseDialog();
                handleGetList();


                handleSnackbar(response?.data?.message, Severity.success);
            }

        } catch (error) {
            console.log(error, error?.message, "login errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setTimeout(() => {
                setLoading(false);

            }, 1000);
        }
    }


    // get label list
    // useEffect(() => {
    //     if (activeProject?.name) {
    //         handleGetList();
    //     }
    // }, [activeProject?.name]);

    return (
        <Box className="w-full h-full flex flex-col gap-1  " >
            <Box className="flex gap-4 px-0 py-0 w-full h-full relative">


                <Box className="absolute bottom-0 right-0 z-10">
                    <LightTooltip title={`Add Label`}>
                        <Fab
                            color="secondary"
                            // disabled={openEditStoryDialog}
                            onClick={() => handleOpenDialog(false)}
                            sx={{ boxShadow: "none" }}>
                            <Add />
                        </Fab>
                    </LightTooltip>
                </Box>




                {/* main container */}
                <Box className="flex gap-4 px-0 py-0 w-full h-full relative overflow-y-auto">


                    {/* list container */}
                    <Box className="flex  items-center flex-wrap gap-4 px-0 py-0 pb-16 w-full h-fit  ">
                        {labelList?.map((label, index) => (
                            <Box key={index} className="flex items-center gap-2 px-4 py-2 w-full max-w-52  h-fit min-h-14 " borderRadius={theme.shape.borderRadius} bgcolor={"background.default"}>

                                <Label sx={{ color: label?.colorCode }} />


                                <Typography
                                    fontSize={font.size.fs_5}
                                    color="textSecondary "
                                    className="flex-1 line-clamp-2"
                                    noWrap
                                    overflow="hidden"

                                >
                                    {label?.name}
                                </Typography>

                                <Box className="flex items-center ">
                                    <IconButton
                                        onClick={() => {
                                            // handleEdit(label);
                                            handleOpenDialog(true, label);
                                        }}
                                    >
                                        <EditOutlined />
                                    </IconButton>

                                    <IconButton
                                        onClick={() => {
                                            handleOpenDeleteDialog(label);
                                        }}
                                    >
                                        <DeleteOutline />
                                    </IconButton>
                                </Box>

                            </Box>
                        ))}

                    </Box>



                </Box>




            </Box>



            {/* add / update dialog */}
            <AddUpdateLabelDialog
                open={openDialog}
                data={currentLabelData}
                isEdit={isEditMode}
                handleClose={handleCloseDialog}
            />

            {
                openDeleteDialog &&
                <DeleteConfirmationDialog
                    open={openDeleteDialog}
                    data={`${currentLabelData?.name}`}
                    handleClose={handleCloseDeleteDialog}
                    handleContinue={handleContinueDeleteDialog}
                />
            }

        </Box>
    )
}